import { render, staticRenderFns } from "./GiftList2.vue?vue&type=template&id=6c28dcdb&scoped=true"
import script from "./GiftList2.vue?vue&type=script&lang=js"
export * from "./GiftList2.vue?vue&type=script&lang=js"
import style0 from "./GiftList2.vue?vue&type=style&index=0&id=6c28dcdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c28dcdb",
  null
  
)

export default component.exports